import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SocialCausesService } from '@shared/services/social-causes.service';

@Component({
  selector: 'app-more-details',
  templateUrl: './more-details.component.html',
  styleUrls: ['./more-details.component.scss'],
})
export class MoreDetailsComponent  implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() me: any;
  constructor(
    private translate: TranslateService,
    private socialCausesService: SocialCausesService
  ) {}

  ngOnInit() {}

  lookingForOptions() {
    if (this.me.lookingFor != null) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const optionsChosen: any = [];

      this.me.lookingFor.forEach((option: string | string[]) => {
        optionsChosen.push(this.translate.instant(option));
      });

      return optionsChosen.join(", ");
    } else {
      return "";
    }
  }

  setHeight() {
    const heightValueFoot = this.me.height * 0.0328084 | 0;  //cm -> feet
    const heightValueInch = ((this.me.height * 0.0328084) - heightValueFoot) * 12 | 0; //feet -> inches

    return ((this.me.height / 100) + " m / " + heightValueFoot + "'" + heightValueInch);
  }

  getSocialCauseDisplayText(causeId: string): string {
    return this.socialCausesService.getSocialCauseDisplayText(causeId);
  }

}


